import type { ListingReducerProps } from './listing';

export type ListingErrorsReducerProps = {
  type: keyof ListingReducerProps | 'listing';
  payload:
    | string
    | JSX.Element
    | Array<string | JSX.Element>
    | Record<string, string | JSX.Element | Array<string | JSX.Element>>;
};

export type ListingErrorsReducerState = Partial<
  Record<keyof ListingReducerProps | 'listing', string | JSX.Element | Array<string | JSX.Element>>
>;

const listingErrors = (state: ListingErrorsReducerState, action: ListingErrorsReducerProps) => {
  const { type, payload } = action;

  if (type === 'listing') {
    return payload as ListingErrorsReducerState;
  }

  return { ...state, [type]: payload } as ListingErrorsReducerState;
};

export default listingErrors;
